module.exports = __webpack_public_path__ + "media/images/workplace/SVG/clickworker_ap_provider-f92b985b100da7327dbf9006ccdba81a.svg";